import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import "./general-enquiry.scss";
import GeneralEnquiryAPI from "../../services/GeneralEnquiry/GeneralEnquiry";
import Header from "../../components/header/header";
import Button from "../../components/button/button";
import ImageUpload from "../../components/imageUpload/imageUpload";
import ModalPopUp from "../../components/modal/modal";
import Loader from "../../components/loader/loader";
import { statusCode } from "../../services/apiConstants";
import Success from "../../assets/PaymentSuccess.json";
import Error from "../../assets/PaymentFail.json";
import Input from "../../components/input/input";
import TextArea from "../../components/text-area/text-area";
import {pageUrl} from "../../utils/pageConstant";
import phoneIcon from "../../assets/phoneIcon.svg";
import mailIcon from "../../assets/mailIcon.svg";

const GeneralEnquiry = () => {
  const navigate = useNavigate();
  const form = useForm();
  const { handleSubmit, register, formState } = form;
  const { errors } = formState;
  const walletReward = useSelector((state) => state.wallet.coins);

  const [uploadedImage, setUploadedImage] = useState({ preview: "", raw: "" });
  const [descContent, setDescContent] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState({});
  const [statusIcon, setStatusIcon] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [isCityBangalore, setIsCityBangalore] = useState(false);
  const city = sessionStorage.getItem("city")||"";

  useEffect(() => {
    window.history.pushState(null, '', '/outlet-list');
  }, []);

  useEffect(() => {
    if(city.toLowerCase().includes("bangalore")){
      setIsCityBangalore(true);
    }
  }, [city])

  const handleBack = () => {
    navigate(pageUrl.HELP);
  };

  const handleQuerySubmit = async (data) => {
    const { title } = data;
    const formData = new FormData();
    formData.append("Topics", "DineIn");
    formData.append("summary", title);
    formData.append("description", descContent);
    formData.append("uploadedFile", uploadedImage?.raw);
    setIsLoader(true);
    try {
      const responseData = await GeneralEnquiryAPI(formData);
      setIsLoader(false);
      if (responseData.statusCode === statusCode.successCode || responseData.statusCode === 204) {
        setIsModalOpen(true);
        setStatusIcon({ icon: Success });
        setMessage({
          title: "Success!",
          text: responseData.message || "Ticket created successfully",
        });
      } else if (responseData.statusCode === statusCode.errorCode) {
        setIsModalOpen(true);
        setStatusIcon({ icon: Error });
        setMessage({
          title: "Error!",
          text: responseData.message || "An unexpected error occurred",
        });
      }else{
        setIsModalOpen(true);
        setStatusIcon({ icon: Error });
        setMessage({
          title: "Error!",
          text: "Unable to submit data..",
        });
      }
    } catch (error) {
      setIsLoader(false);
      console.error("Error occurred while adding comaplain :",error)
      setIsModalOpen(true);
      setStatusIcon({ icon: Error });
      setMessage({
        title: "Error!!",
        text: "An unexpected error occurred",
      });
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    navigate(pageUrl.HELP);
  };

  // const handleUploadImage = (e) => {
  //   if (e.target.files.length) {
  //     setUploadedImage({
  //       preview: URL.createObjectURL(e.target.files[0]),
  //       raw: e.target.files[0],
  //     });
  //   }
  // };

  const handleTextAreaChange = (e) => {
    setDescContent(e.target.value);
  };

  return (
    <div className="enquiry-page">
      {isLoader && <Loader />}
      <Header coin={walletReward} onClick={handleBack} label="General Enquiry" />
      {/* <label className="title">General Enquiry</label> */}
      <div className="enquiry-content">
        <form
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit(handleQuerySubmit)}
        >
          <Input
            name="title"
            type="text"
            register={register}
            errors={errors}
            className="input-email"
            validationRules={{
              required: "Title is required",
              pattern: {
                value: /(?!^$)([^\s])/,
                message: "Invalid title text",
              },
            }}
          />
          <TextArea placeholder="Write here" onChange={handleTextAreaChange} />
          {/* <ImageUpload
            onChange={handleUploadImage}
            uploadImage={uploadedImage}
          /> */}
          <div className="btn-section">
            <Button btnText="Submit" btnStyle="button-style" />
          </div>
        </form>
      </div>
      <div className="contactSection">
        <div className="contactTitle">
            <h1>Contact Us</h1>
        </div>
        <div className="contactDetails">
          <p className="contactText"><img src={phoneIcon}/>{isCityBangalore?"+91 9742405047":"+91 9076123111"}</p>
          <p className="contactText"><img src={mailIcon}/>support@cheggout.com</p>
        </div>
      </div>
      {isModalOpen && (
        <ModalPopUp
          isOpen={isModalOpen}
          handleModalClose={handleCloseModal}
          message={message}
          icon={statusIcon.icon}
        />
      )}
    </div>
  );
};

export default GeneralEnquiry;
